// removed by extract-text-webpack-plugin
module.exports = {"searchResults":"_3rFC4","title":"_2n_X3","table":"_2MVru","inventoryRecordsList":"_2cH3_","loadMoreButton":"_30FkH","filterOptions":"_2dPRf","filterOption":"_3iJEJ","label":"_35lu5","sortByPretext":"_3_bx2","filter":"GzeS8","applied":"_3DiIQ","count":"_1abut","suggestedFiltersFilterOption":"_3bmFg _3iJEJ","marketingMessage":"qR00n","sortBySelect":"_1JBqT","light":"RjS9H","filterListWrapper":"_2AGiQ","filterList":"_3J6Yq"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventorySearchResults/index.sass
// module id = 1484
// module chunks = 1